import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { login,responseLogin } from '../../models/login/login.model'
import { HttpClient, HttpHeaders, } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { byPassJwToken } from '../common/interceptor.service'

enum ServicesLogin {
  login = "login"
}

const httpOptions = {
  context: byPassJwToken()
}

declare const gapi: any;

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  public auth2: any;
  /* @ts-ignore*/
  private responseLogin : responseLogin;
  // url = `${environment.urlSesio}/${ServicesLogin.login}`;
  constructor(private http: HttpClient) { }

  private extractData(res: Response) {
    let body = res;
    return body || {};
  }

  // loginPortal(data: login): Observable<responseLogin> {
  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //         'Authorization': 'Basic ' + btoa(data.userName+":"+ data.password)          
  //     })
  //   };    

  //   if (data.ambiente && data.ambiente != '') { 
  //     this.url = `${environment.urlSesio}/${ServicesLogin.login}/${data.ambiente}` 
  //   }
  //   return this.http.get<responseLogin>(this.url, httpOptions).pipe( tap((_response) => ( this.responseLogin = _response))  );
  // }

  googleInit() {

    return new Promise<void>(resolve => {
      gapi.load('auth2', () => {
        // Retrieve the singleton for the GoogleAuth library and set up the client.
        this.auth2 = gapi.auth2.init({
          client_id: '906858578304-s43krf4lbdmu8brmgg2qj0p7j8ghklf6.apps.googleusercontent.com',
          cookiepolicy: 'single_host_origin',
        });
        resolve();
      });
    })
  }

  // loginGoogle(token: any, metodo?: string | null){
  //   const httpOptions = { 
  //   headers : new HttpHeaders({
  //     'Authorization': `Bearer ${token}`
  //   })
  //   }
  //   return this.http.get(`${this.url}/${metodo}`,httpOptions);
  // }

    // getcacheSession(cache: any): Observable<any> {  
    //   return this.http.get(`${environment.urlSesio}/${cache}`,httpOptions );     
    // }
}